module.exports = __webpack_public_path__ + "static/media/摄图网_4.ed0aed99.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_208/images/摄图网_4.png
// module id = 1708
// module chunks = 0